import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import type { FC } from 'react'
import { useQueryClient } from 'react-query'
import TeamMemberEditScreen from './TeamMemberEdit'

export const TeamMemberEditScreenRedirect: FC = () => {
  const { hasRota } = useHomeType()

  const queryClient = useQueryClient()

  const flags = useFeatureFlags({
    flagNames: [
      'team_member',
      'rostering_change_management',
      'group_access_management',
      'email_incident_notifications',
      'team_profile_redesign'
    ]
  })?.data

  const teamMemberEnabled = flags?.team_member?.enabled
  const flagsRosteringChangeManagement =
    flags?.rostering_change_management?.enabled

  const groupAccessManagementEnabled = flags?.group_access_management?.enabled

  const emailIncidentNotificationsFlagEnabled =
    flags?.email_incident_notifications?.enabled

  // TODO(CM-3663 Q1): confirm/replace this flag name once the parent redesign
  // flag is finalised.
  const profileRedesignEnabled = flags?.team_profile_redesign?.enabled

  return (
    <TeamMemberEditScreen
      teamMemberEnabled={teamMemberEnabled}
      hasRota={hasRota}
      flagsRosteringChangeManagement={flagsRosteringChangeManagement}
      queryClient={queryClient}
      groupAccessManagementEnabled={groupAccessManagementEnabled}
      emailIncidentNotificationsFlagEnabled={
        emailIncidentNotificationsFlagEnabled
      }
      profileRedesignEnabled={profileRedesignEnabled}
    />
  )
}
